import React, { Component } from 'react'
import ReactTable from "react-table"
import { connect } from 'react-redux'
import { Grid, Row, Col, Badge } from 'react-bootstrap'
import ReactJson from 'react-json-view'
import dayjs from 'dayjs'

import { tableColumnHelper } from './Utils'

import { getSesamThreads } from '../redux/dataAnalyticsActions'


class SesamAllThreadsTable extends Component {
    constructor(p) {
        super(p)

        this.state = { enteredCellIndex: null }

    }

    renderTransformedResult = (t) => {
        return t.map((field, i) => {
            return (
                <div key={i}>
                    <p><b>{field.label}</b>: {typeof field.value !== "string" ? <ReactJson collapsed={field.collapsed || false} displayDataTypes={false} name={false} displayObjectSize={false} src={field.value} /> : field.value}</p>
                </div>
            )
        })
    }

    renderCell = (payload) => {
        return JSON.stringify(payload)
    }

    renderInnerText = (direction, obj) => {
        if (direction === "request") return <ReactJson collapsed={false} displayDataTypes={false} name={false} displayObjectSize={false} src={obj.payload} />

        return <ReactJson collapsed={false} displayDataTypes={false} name={false} displayObjectSize={false} src={obj.response || {}} />
    }


    defaultFilterMethod = (filter, data) => {
        if (!data) return false

        return JSON.stringify(data).toLowerCase().indexOf(filter.value.toLowerCase()) > -1
    }

    createBadgeCell = (v) => {
        const l = v.original[v.column.id].length
        if (l) return <Badge style={{ backgroundColor: 'green' }}>{l}</Badge>

        return <Badge>{l}</Badge>
    }

    componentWillMount() {
        this.props.getSesamThreads()
    }

    render() {
        const { sesamThreads = [], locks } = this.props

        // const tableColumns = tableColumnHelper(this, 'threads')

        const tableColumns = [
            {
                Header: "Senaste event:",
                id: 'latest',
                accessor: d => dayjs(d.latestEvent).format("DD/MM HH:mm"),
                maxWidth: 150
            },
            {
                Header: "Lås:",
                id: 'lock',
                accessor: d => {
                    let lock
                    try {
                        const publicId = d.virtualLockId.split('-')[0]
                        lock = this.props.sesamLockDescriptions[publicId]

                        if (!lock) return "Lås ej på detta konto"
                    } catch (e) {
                        console.log(e)
                        return "Kan ej fastställa id"
                    }

                    return lock.custom_name
                }
            },
            {
                Header: "AccessRequests:",
                id: 'accessRequests',
                Cell: this.createBadgeCell
            },
            {
                Header: "AccessKeys:",
                id: 'accessKeys',
                Cell: this.createBadgeCell
            }, {
                Header: "AccessEvents:",
                id: 'accessEvents',
                Cell: this.createBadgeCell
            },
            {
                Header: 'Tråd',
                id: 'traceid',
                Cell: ({ original }) => {
                    const publicId = original.virtualLockId.split('-')[0]
                    const lock = this.props.sesamLockDescriptions[publicId] || {}

                    return (
                        <div>
                            {original.virtualLockId ? <p className="HotspotterLink" onClick={() => this.props.onThreadClick(original.virtualLockId, lock)}>Öppna tråd</p> : 'Ingen tråd'}
                        </div>
                    )
                },
                maxWidth: 100
            }
        ]


        return (
            <Grid fluid>
                <Row>
                    <Col xs={12} md={12} lg={12}>

                        <h4>Antal: {sesamThreads.length}</h4>

                        <ReactTable
                            data={sesamThreads}
                            filterable
                            columns={tableColumns}
                            NoDataComponent={props => (null)}
                            showPagination={true}
                            showPageSizeOptions={false}
                            loading={!sesamThreads.length || !locks}
                            loadingText="Laddar..."
                            pageSize={sesamThreads.length > 30 ? 30 : sesamThreads.length}
                            className="-striped -highlight"
                            // SubComponent={(o) => { const document = o.original; return <div style={{ padding: 10 }}>{JSON.stringify(document.payload)}</div> }}
                            defaultFilterMethod={(filter, row) => {
                                const id = filter.pivotId || filter.id
                                return row[id] !== undefined ? String(row[id].toLowerCase()).indexOf(filter.value.toLowerCase()) > -1 : true
                            }}
                        />
                    </Col>
                </Row>
            </Grid>
        )
    }
}

const mapProps = state => {
    return {
        locks: state.collectionData.locks,
        sesamLockDescriptions: state.dataAnalytics.sesamLockDescriptions,
        sesamThreads: state.dataAnalytics.sesamThreads
    }
}

const mapDispatch = dispatch => {
    return {
        getSesamThreads: (...args) => dispatch(getSesamThreads(...args))
    }
}

export default connect(mapProps, mapDispatch)(SesamAllThreadsTable)
